import React, { useState, useEffect } from 'react'
import Ripples from 'react-ripples'
import { Container, Col, Row, Button } from "react-bootstrap";
import { useSpring, animated } from "react-spring";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../commons/inFormTypes";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function TimeSpan() {
    // const [isOpen, setIsOpen] = useState(false);
    const [time1, setTime1] = useState("am");
    const [day, setDay] = useState("");
    const [date, setDate] = useState("");
    const [seenFile, setSeenFile] = useState([]);
    const [locId, setLocId] = useState(0);

    const [registrationFormStatus, setRegistartionFormStatus] = useState(false);
    const navigate = useNavigate();

    const userToken = localStorage.getItem("user_token");
    const mstr = JSON.parse(localStorage.getItem("Master"));

    const morningBtnProps = useSpring({
        borderBottom: registrationFormStatus
            ? "solid 4px transparent"
            : "solid 4px #E78E09",  //Animate bottom border of login button
    });

    const afternoonBtnProps = useSpring({
        borderBottom: registrationFormStatus
            ? "solid 4px #E78E09"
            : "solid 4px transparent", //Animate bottom border of register button
    });

    const afternoonClicked = () => {
        setRegistartionFormStatus(true);
        if (time1 === "am")
            setTime1("pm")

    }

    const morningClicked = () => {
        setRegistartionFormStatus(false);
        if (time1 === "pm")
            setTime1("am")
    }

    
    useEffect(() => {
        if (userToken == null) {
            navigate("/");
        } else {
            const axios = require("axios");
            axios
                .post(apiUrl + "Get_ListTime", {
                    AreaId: mstr[0].Type_Area_Id,
                    Type: time1,
                    deliveryId: mstr[0].deliveryId,
                })

                .then((res) => {
                    if (res.data.result === "true") {
                        setSeenFile(res.data.data);
                    } else {
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        toast.error(error.response.data.message, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                });
        }
    }, [time1]);

    const RadioHandlerChange = (val, day, date) => {
        setLocId(val);
        setDay(day);
        setDate(date);
    }

    const nextHandler = () => {
        if (locId === 0) {
            toast.error("بازه زمانی مورد نظر را انتخاب کنید", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            navigate("../finalinfo")
            mstr[0].day = day;
            mstr[0].date = date;
            mstr[0].time = time1;

            localStorage.setItem("Master", JSON.stringify(mstr));
        }
    }



    return (
        <div>
            <Container>
                <Row className="justify-content-center mb-3">
                    <Col xs={11} lg={9} className="mt-3">
                        <Row className="justify-content-center gy-3 gx-5">

                            <Col xs={12}>
                                <div className="d-flex rgc-title pt-1">
                                    <div className="rgc-title-point"></div>
                                    <h4>بازه های زمانی <span>تحویل زباله</span></h4>
                                </div>
                            </Col>

                            <Col xs={12} className="my-3">
                                <Row className="justify-content-center">

                                    <Col xs={6} md={3} >
                                        <animated.button
                                            onClick={morningClicked}
                                            id="loginBtn"
                                            style={morningBtnProps}
                                            className='rgc-select-btn'
                                        >
                                            <span>بازه های صبح 8-13</span>
                                        </animated.button>
                                    </Col>

                                    <Col xs={6} md={3} className="rgc-dash-filter">
                                        <animated.button
                                            className='rgc-select-btn'
                                            onClick={afternoonClicked}
                                            id="registerBtn"
                                            style={afternoonBtnProps}
                                        >
                                            <span>بازه های عصر 15-20</span>
                                        </animated.button>
                                    </Col>
                                </Row>
                            </Col>

                            {seenFile.map((data, index) => {
                                return (
                                    <Col xs={12} md={6} key={index}>
                                        <Ripples className="rgc-ripple">
                                            <Row
                                                className={locId === data.id.toString() ?
                                                    "justify-content-center  rgc-station-time rgc-station-select"
                                                    : "justify-content-center  rgc-station-time"}>
                                                <Col xs={2}>
                                                    <div className="radio">
                                                        <input
                                                            type="radio"
                                                            value={data.id.toString()}
                                                            className="rgc-checkbox mt-2 me-2"
                                                            checked={locId === data.id.toString()}
                                                            onChange={(e) => RadioHandlerChange(e.target.value, data.day, data.date)}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col xs={5} className="text-end rgc-day">
                                                    <span>{data.day} </span>
                                                </Col>

                                                <Col xs={5} className="text-center">
                                                    <span>{data.date}</span>
                                                    <i className="fa-regular fa-calendar-days mx-1"></i>
                                                </Col>

                                            </Row>
                                        </Ripples>
                                    </Col>
                                )
                            })}
                            <Col xs={5} md={4} className="text-center pt-4 pt-sm-0">
                                <Button onClick={nextHandler} className="rgc-order-btns rgc-order-btn-sub" >
                                    مرحله بعد
                                </Button>
                            </Col>

                            <Col xs={5} md={4} className="text-center pt-4 pt-sm-0">
                                <Button onClick={() => navigate(-1)} className="rgc-order-btns rgc-order-btn-sub" >
                                    مرحله قبل
                                </Button>
                            </Col>

                        </Row>
                    </Col>
                </Row>
            </Container>
            {/* <OrderForm toggle={isOpen} toggleHandler1={toggleHandler} /> */}
        </div>
    )
}

export default TimeSpan